<style scoped="scoped" lang="scss">
.hideFormItem {
  display: none !important;
}

.container {
  padding-left: 24px;
  padding-right: 24px;
  overflow: auto;
  min-width: 500px;

  // 隐藏表单项
  .hideFormItem {
    display: none !important;
  }
}
</style>
<style>
.el-radio-button__orig-radio:checked+.el-radio-button__inner {
  color: #419fff;
  background-color: #FFFFFF;
  border-color: #419fff;
  /*-webkit-box-shadow: -1px 0 0 0 #419fff;*/
  box-shadow: -1px 0 0 0 #419fff;
}
</style>
<template>
  <div class="container">
    <div>
      <div style="z-index: 11">
        <el-radio-group size="mini" v-model="tabPosition" style="margin-bottom: 10px;margin-left: -22px;display: flex;flex-wrap: nowrap">
          <el-radio-button @click="tabChange" :label="1"  >{{$t('zuzhi-banci-chanpin')}}</el-radio-button>
          <el-radio-button @click="tabChange" :label="2" >{{$t('zuzhi-banci-shebei-chanpin')}}</el-radio-button>
          <el-radio-button @click="tabChange" :label="3" >{{$t('zuzhi-banci-gongdan-chanpin')}}</el-radio-button>
        </el-radio-group>
        <div v-show="tabPosition==1">
          <monthly_one> </monthly_one>
        </div>
        <div v-show="tabPosition==2">
          <monthly_two></monthly_two>
        </div>
        <div v-show="tabPosition==3">
          <monthly_three></monthly_three>
        </div>
      </div>
    </div>
  </div>
</template>
<script type="text/javascript">
import monthly_one from '@@/pages/web/report/mes_produce_report/mes_production/mes_tabs/monthly_one'
import monthly_two from '@@/pages/web/report/mes_produce_report/mes_production/mes_tabs/monthly_two'
import monthly_three from '@@/pages/web/report/mes_produce_report/mes_production/mes_tabs/monthly_three'

export default {
  name: 'web_report_mes_producee_report_mes_tabs',
  components: {
    monthly_one,
    monthly_two,
    monthly_three
  },
  data() {
    return {
      // activeName: 'first',
      tabPosition: 1,
      // tab:1
    }
  },
  methods:{
    tabChange(e){
      let tabid = e.target.dataset.id
      this.tabPosition = tabid
    }
  }
}
</script>
